import React, { useEffect, useRef, useState } from 'react';
import './index.less';
import ActivityControlIntro from '../activity-control-intro';
import Modal from '@/components/modal';
import ComponentLog from '@/components/component-log';
import { withRouter } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import QueueAnim from 'rc-queue-anim';
import { connect } from 'react-redux';
import { checkPowerCreateActivity } from '@/common/utils/helper';
import CreateActivityAuthModal from '@/components/nopower/noPower-modal';
import utils from '@/common/utils';
import goTo from '@/common/goto';

const BannerItem = ({ src, title, des, setPopStatus }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div
      style={{ position: 'relative', height: '100%' }}
      onMouseEnter={() => {
        setVisible(true);
      }}
      onMouseLeave={() => {
        setVisible(false);
      }}
    >
      <div className="activity-control__click-item" style={visible ? { filter: 'blur(10px)' } : {}}>
        <img width={90} height={90} src={src} />
        <div>
          {title}
          <RightOutlined style={{ fontSize: 6, paddingLeft: 4 }} />
        </div>
      </div>
      {visible ? (
        <QueueAnim animConfig={[{ opacity: [1, 0] }]} ease="easeInOutQuad">
          <div key="1" className="activity-control__click-item__hover">
            <div style={{ position: 'relative', height: '100%' }}>
              <div className="activity-control__click-item__hover__des">{des}</div>
              <div
                className="activity-control__click-item__hover__button"
                onClick={() => {
                  setPopStatus();
                }}
              >
                试试看
                <RightOutlined style={{ fontSize: 9, paddingLeft: 1 }} />
              </div>
            </div>
          </div>
        </QueueAnim>
      ) : null}
    </div>
  );
};

function ActivityControl(props) {
  const [popStatus, setPopStatus] = useState(0);
  const [visibility, setVisibility] = useState(false);
  const { style } = props; // 两种展现形式，'whole', 'simple'

  const onClose = () => {
    setVisibility(false);
  };

  const showPopup = (value) => {
    setPopStatus(value);
    setVisibility(true);
  };

  const noAuthModalRef = useRef(null);

  const noPowerMessage = () => {
    noAuthModalRef.current.show({ resCode: '1-2-1' });
  };

  const toCreate = (type) => {
    switch (type) {
      case 'tradition':
        goTo.promotionActivityCreate().push();
        break;
      case 'merchant':
        goTo.merchantActivityCreate().push();
        break;
    }
  };

  useEffect(() => {
    if (visibility) {
      document.getElementById('root').style = 'filter: blur(10px)';
    } else {
      document.getElementById('root').style = '';
    }
  }, [visibility]);

  return (
    <>
      {visibility && (
        <Modal>
          <ActivityControlIntro introType={popStatus} onClose={onClose} />
        </Modal>
      )}
      <div className={'activity-control-wrapper' + (style === 'whole' ? ' whole' : ' simple')} id="step5">
        {style === 'whole' && (
          <div className="activity-control__click-item-wrapper">
            <BannerItem
              src="//img13.360buyimg.com/imagetools/jfs/t1/125154/23/20183/8244/60bd8e99E8607cfbb/424a9c85e716742d.png"
              title="会场运营"
              des="查看活动关联会场，全面掌握会场信息。"
              setPopStatus={() => {
                showPopup(0);
              }}
            />
            <BannerItem
              src="//img12.360buyimg.com/imagetools/jfs/t1/191534/22/6912/6782/60bd8e99E53bebd76/6fb4f6de02931d0c.png"
              title="活动选品"
              des="对活动商品进行统一的收集、管理，提升活动运营效率。"
              setPopStatus={() => {
                showPopup(2);
              }}
            />
            <BannerItem
              src="//img14.360buyimg.com/imagetools/jfs/t1/131268/23/17529/7049/60bd8e99E3c616e94/537dbb48e5de51af.png"
              title="综合促销"
              des="在主题活动下玩转促销、优惠券、打标、膨胀金活动。"
              setPopStatus={() => {
                showPopup(3);
              }}
            />
          </div>
        )}
        <img
          className="activity-control__absolute-rect"
          src={utils.resizeImg(
            '//img13.360buyimg.com/imagetools/jfs/t1/6104/7/11308/17765/60bdf109Ed95d64a2/ef95c39654fb41b5.png',
            532,
            253
          )}
        />
        <div className="activity-control-item-1">
          <div className="activity-control-item-text">
            <div className="activity-control-item-title">快速创建主题营销活动</div>
            <div className="activity-control-item-content">涵盖页面设计/素材管理/提报/运营推广等业务流程</div>
          </div>
          <ComponentLog>
            <div
              clstag="hd_gallery_1606447516680|4"
              className="activity-control-item-button"
              onClick={() => {
                props.checkPowerCreateActivity(() => toCreate('merchant'), noPowerMessage);
              }}
            >
              <a>创建活动</a>
            </div>
          </ComponentLog>
        </div>
        <CreateActivityAuthModal ref={noAuthModalRef} />
      </div>
    </>
  );
}

export default withRouter(
  connect((state) => {
    return {
      checkPowerCreateActivity(resolve, reject) {
        return checkPowerCreateActivity(state.userInfo, resolve, reject);
      },
    };
  })(ActivityControl)
);
